import { NavigationGuard } from "vue-router";
import { userModule } from "@/store/modules/user";

export const SKRINING_PENGUNJUNG_HOME = "skrining-pengunjung-input";

const RUTE_DIIZINKAN = [
  SKRINING_PENGUNJUNG_HOME,
  "skrining-pengunjung-laporan",
  "user-profile",
  "Login",
  "Forbidden",
  "ErrorPage"
];

const skriningPengunjungModeGuard: NavigationGuard = (to, _from, next) => {
  if (!userModule.isSignedIn || !userModule.isModeSkriningPengunjung) {
    return next();
  }

  if (to.name && RUTE_DIIZINKAN.includes(to.name)) {
    return next();
  }

  return next({ name: SKRINING_PENGUNJUNG_HOME, replace: true });
};

export default skriningPengunjungModeGuard;
